import axios from 'axios'
;

const axiosInstance = axios.create({
    baseURL: 'https://budva.scancar.org:8443/kuca', // Zameni sa svojim API URL-om
});

// Dodaj interceptor za svaki request
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('access_token'); // Preuzmi token iz localStorage-a ili drugog mesta
        console.log("TOKEN: "+token);
        if (token) {
            config.headers.Authorization = `${token}`;
        }
        // const tenant = localStorage.getItem('tenant'); // Preuzmi token iz localStorage-a ili drugog mesta
        // console.log("TENANT: "+tenant);
        // if (tenant) {
        //     config.headers.tenant = tenant;
        // }
        config.headers['Cache-Control'] = 'no-cache';
        // config.headers['Pragma'] = 'no-cache'; // Opcionalno, za dodatnu kompatibilnost sa starijim serverima
        // config.headers['Expires'] = '0';
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Dodaj response interceptor za hvatanje grešaka
axiosInstance.interceptors.response.use(
    (response) => {
        // Ako je odgovor uspešan, samo ga prosledi dalje
        return response;
    },
    (error) => {
        // Ako server vrati 401, preusmeri korisnika na login stranicu
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('access_token');
            window.location.href = '/#/login'; // ili window.location.replace('/login');
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;